export default __webpack_public_path__ + "static/media/silver-nft.05e45074.png";